import React, { memo, useCallback } from 'react';
import { Text } from '@cuemath/web-comps';
import COLORS from 'constants/colors';
import { Thumbnail, ViewedDot } from './chunk-thumbnail-styled';

const ChunkThumbnail = ({ chunk, index, isActive, onSelect }) => {
  const isVideo = chunk.evidence_type === 'video';
  const handleClick = useCallback(() => onSelect(index), [onSelect, index]);

  return (
    <Thumbnail isActive={isActive} onClick={handleClick}>
      {chunk.is_viewed && <ViewedDot />}
      <Text variant="body3">{isVideo ? '\u25B6' : '\uD83D\uDDBC'}</Text>
      <Text variant="body3" color={COLORS.BLACK_T_60}>{isVideo ? 'video' : 'image'}&nbsp;{index + 1}</Text>
    </Thumbnail>
  );
};

export default memo(ChunkThumbnail);
